import { ProtocolItemModel } from 'shared/domain/inspection/inspectionModel';
import { InspectionTemplateModel } from 'shared/domain/template/inspectionTemplateModel';
import { ProtocolAnswerUpdateOutDto } from 'shared/dtos/out/protocolAnswer';
import { HashMap } from 'shared/types/commonView';
import { areObjectIdsEqual } from 'helpers/idComparison';

import { collectProtocolAnswerSubmitTasksForChecklistItem } from './collectProtocolAnswerSubmitTasks';

type PutProtocolAnswer = (
  inspectionId: string,
  protocolItemId: string,
  protocolAnswerId: string,
  body: ProtocolAnswerUpdateOutDto,
  signal: AbortSignal,
  projectId: string
) => Promise<unknown>;

export async function putPendingProtocolAnswersForChecklistItem(args: {
  form: HashMap<unknown>;
  template: InspectionTemplateModel;
  protocolItems: ProtocolItemModel[] | undefined;
  checklistItemId: string;
  inspectionId: string;
  projectId: string;
  putProtocolAnswer: PutProtocolAnswer;
  signal: AbortSignal;
}): Promise<void> {
  const {
    form,
    template,
    protocolItems,
    checklistItemId,
    inspectionId,
    projectId,
    putProtocolAnswer,
    signal,
  } = args;

  const tasks = collectProtocolAnswerSubmitTasksForChecklistItem(
    form,
    template,
    protocolItems,
    checklistItemId
  );

  if (!tasks.length) {
    return;
  }

  const protocolItemsList = protocolItems ?? [];

  for (const task of tasks) {
    const protocolItem = protocolItemsList.find((item) =>
      areObjectIdsEqual(item.templateChecklistItem, task.checklistItemId)
    );
    const protocolAnswer = protocolItem?.answers?.find((answer) =>
      areObjectIdsEqual(answer.checklistAnswerId, task.checklistAnswerId)
    );

    if (!protocolItem?._id || !protocolAnswer?._id) {
      throw new Error(
        'Protocol answer stub not found while saving pending protocol answers'
      );
    }

    await putProtocolAnswer(
      inspectionId,
      protocolItem._id,
      protocolAnswer._id,
      task.body,
      signal,
      projectId
    );
  }
}
